var _defs, _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMolexLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 546.35 204.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 289.58,
    y: 38.56,
    width: 24.67,
    height: 97.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.34,79.95c9.06-.51,14.77,9.25,14.77,22.21,0,16.66-5.71,23.9-15.11,23.9-8.89,0-15.1-7.24-15.1-23.9,0-9.93,3.53-22.21,15.44-22.21ZM202.04,104.1c0,23.84,17.28,36.06,39.62,36.06s39.62-11.95,39.62-37.53c0-21.72-15.16-36.21-39.75-36.21s-39.5,13.44-39.5,37.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M363.98,123.15c-7.04,0-13.18-5.45-13.18-13.68h50.8c.38-25.14-14.59-43.05-39.42-43.05-21.47,0-37.93,14.72-37.93,37.45s16.6,36.29,38.05,36.29c15.62,0,32.5-5.74,37.11-23.05h-25.45c-1.93,4.05-5.76,6.04-9.99,6.04ZM374.99,95.32h-24.19c-.06-18.04,24.39-18.22,24.19,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.56,136.12v-42.82c.01-6.67,5.42-12.08,12.1-12.08s12.1,5.41,12.1,12.08v42.81s23.68,0,23.68,0l.02-51.03c-.39-4.82-5.11-11.91-10.78-15.03-7.65-3.69-24.71-7.87-38.86,7.66-4.54-4.83-10.21-8.51-16.45-10.21-10.5-2.27-21.49.04-29.14,7.97-1.06.89-1.89,3.02-1.82,1.24v-8.64h-24.35v68.05h24.35v-42.87c0-6.67,5.42-12.09,12.1-12.09s12.08,5.42,12.08,12.09v42.87s24.98,0,24.98,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M454.36,68.06l-11.62,16.51c-3.64-5.04-6.97-11.19-10.3-16.51h-27.41l21.41,31.58s-15.96,23.75-24.42,36.47h23.95s13.37-21.55,13.37-21.55c2.22,3.2,7.4,13.25,12.56,21.55h26.4c-6.64-10.93-22.51-36.58-22.51-36.58,6.53-10.77,15.31-20.7,22.11-31.47h-23.53Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMolexLogo);
export default __webpack_public_path__ + "static/media/molex-logo.4611bb282e2ed438ec879f9df359116d.svg";
export { ForwardRef as ReactComponent };